import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import BUTTON from "../button/Button.component";
import { DefaultModalProps, IModalProps } from "./Modal.types";
import ModalStyles from "./Modal.styles";
import PinModeIcon from "../../theme/assets/map-controls/add_light_new.svg";
import PlusIcon from "../../theme/assets/map-controls/plus.svg";
import StreetlightIcon from "../../theme/assets/map-markers/dot_streetlight.svg";
import MapStyles from "../map/Map.styles";

const PIN_MODE_MODAL: React.FC<IModalProps> = (props: IModalProps) => {
  const [show, setShow] = useState(false);
  const { handleClose, centered } = props;

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <ModalStyles.PinModeModal
      dialogClassName="pin-mode-modal"
      backdrop="static"
      show={show}
      keyboard={false}
      centered={centered}
      onHide={handleClose}
    >
      <ModalStyles.PinModeModalHeader className="pin-mode-modal-header">
        <Modal.Title>Reporting A Streetlight Issue</Modal.Title>
      </ModalStyles.PinModeModalHeader>
      <Modal.Body>
        <p>
          To report a streetlight issue, find and select a streetlight on the
          map{" "}
          <img src={StreetlightIcon} alt="Pin Mode Icon" className="pin-icon" />
        </p>
        <p>
          If the streetlight is missing from the map, click the &#34;Add
          Streetlight&#34; button{" "}
          <MapStyles.PinModeContainer className="pin-mode-container in-modal">
            <button
              type="button"
              className="pin-mode-button"
              title="Toggle Pin Mode"
            >
              <img src={PinModeIcon} alt="Pin Mode Icon" className="pin-icon" />
              <img src={PlusIcon} alt="Pin Mode Icon" className="plus-icon" />
            </button>
          </MapStyles.PinModeContainer>
          {"  "} to drop a new marker on the map and report it!
        </p>
      </Modal.Body>
      <Modal.Footer>
        <BUTTON variant="primary" onClick={handleClose}>
          Got It
        </BUTTON>
      </Modal.Footer>
    </ModalStyles.PinModeModal>
  );
};

PIN_MODE_MODAL.defaultProps = DefaultModalProps;
export default PIN_MODE_MODAL;
